module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_17.ebc9f8f2.jpg";